import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Button from "../../Button";
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {FormattedMessage} from "react-intl";
import RespondentForm from "./RespondentForm";

class ButtonAdd extends Component {
  constructor(props) {
    super(props);

    this.respondentForm = React.createRef();

    this.state = {
      modalOpen: false,
      creating: false,
    };

    this.save = this.save.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
  }

  save(){
    this.respondentForm.current.save();
  }

  toggleModal(){
    this.setState({
      modalOpen: !this.state.modalOpen,
    })
  }

  render() {
    const {creating, modalOpen} = this.state;

    return <React.Fragment>
      <Button onClick={this.toggleModal}><i className="fas fa-plus" /> Dodaj nowego respondenta</Button>
      <Modal isOpen={modalOpen} toggle={this.toggleModal} size="lg">
        <ModalHeader tag="h2" toggle={this.toggleModal}>Dodaj nowego respondenta</ModalHeader>
        <hr className="my-0"/>
        <ModalBody>
          <RespondentForm
            baseId={this.props.baseId}
            ref={this.respondentForm}
            onSaved={() => {
              this.toggleModal();
              this.props.onSaved();
            }}
            onSavingStart={() => this.setState({creating: true})}
            onSavingStop={() => this.setState({creating: false})}
          />
        </ModalBody>
        <ModalFooter>
          <FormattedMessage id="_.button.cancel">{
            (message) =>
              <Button color="secondary" className={['mb-0']} onClick={this.toggleModal}>{message}</Button>
          }</FormattedMessage>
          <FormattedMessage id="_.button.save">{
            (message) => <Button
              color="primary"
              loading={creating}
              onClick={this.save}
            >
              {message}
            </Button>
          }</FormattedMessage>
        </ModalFooter>
      </Modal>
    </React.Fragment>;
  }
}

ButtonAdd.propTypes = {
  baseId: PropTypes.number.isRequired,
  onSaved: PropTypes.func.isRequired,
};

export default ButtonAdd;